import { TFunction } from 'i18next';
import _without from 'lodash/without';
import { Documentation } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { hasTextEditorValue } from '@lib/components/TextEditor/utils';

type ActionsMenuArgs = {
  onDelete?: (v: Documentation) => void;
  onDetails: (v: Documentation) => void;
  onEdit?: (v: Documentation) => void;
  onUnlink?: (v: Documentation) => void;
  onVersionNotes?: (v: Documentation) => void;
  onViewDocument?: (v: Documentation) => void;
  t: TFunction<'translation', undefined>;
  unlinkLabel?: string;
};

export default function getTableActionsMenu({
  onDelete,
  onDetails,
  onEdit,
  onUnlink,
  onVersionNotes,
  onViewDocument,
  t,
  unlinkLabel,
}: ActionsMenuArgs) {
  return _without(
    [
      onViewDocument
        ? {
            id: 'view-document',
            title: t('view-document'),
            onClick: (item: Documentation) => onViewDocument(item),
            leftIcon: Icons.description,
            type: NavItemTypeEnum.Secondary,
          }
        : undefined,
      onVersionNotes
        ? {
            id: 'version-notes',
            title: t('version-notes'),
            onClick: (item: Documentation) => onVersionNotes(item),
            leftIcon: Icons.pendingActions,
            type: NavItemTypeEnum.Secondary,
            predictorFnDisable: (item?: Documentation) =>
              !hasTextEditorValue(item?.currentVersion?.notes),
          }
        : undefined,
      {
        id: 'details',
        title: t('details'),
        onClick: (item: Documentation) => onDetails(item),
        leftIcon: Icons.view,
        type: NavItemTypeEnum.Secondary,
      },
      onEdit
        ? {
            id: 'edit-action',
            title: t('edit'),
            onClick: (item: Documentation) => onEdit(item),
            leftIcon: Icons.edit,
            type: NavItemTypeEnum.Secondary,
            predictorFnDisable: (item?: Documentation) =>
              !item?.canUpdate?.value,
          }
        : undefined,
      onUnlink
        ? {
            id: 'unlink-action',
            title: unlinkLabel || t('unlink-from-equipment'),
            onClick: (item: Documentation) => onUnlink(item),
            leftIcon: Icons.linkOff,
            type: NavItemTypeEnum.Secondary,
          }
        : undefined,
      onDelete
        ? {
            id: 'delete-action',
            title: t('delete'),
            onClick: (item: Documentation) => onDelete(item),
            leftIcon: Icons.delete,
            type: NavItemTypeEnum.Secondary,
            predictorFnDisable: (item?: Documentation) =>
              !item?.canDestroy?.value,
          }
        : undefined,
    ],
    undefined,
  ) as NavItem<Documentation>[];
}
